<template>
  <div v-click-outside="lostFocus" class="dropdown text-center" :class="{'displayed':isOpen}">
    <div class="title z-10" :class="{'bg-classen__secondary':isOpen}">
      <div
        class="title-text rounded-20 border-shadow border-classen__secondary bg-white grid grid-cols-5 bg-classen__secondary">
        <div @click="isOpen ? closeSelection() : openSelection()"
             class="col-span-5 overflow-hidden whitespace-nowrap overflow-ellipsis px-1 text-left pl-4 flex">
          <div class="text-2xl ml-2 flex items-center ">
            <p><i class="fas fa-plus"></i></p>
            <p class="text-base ml-2">
              {{ getTranslation('addProduct') }} ({{ getTranslation('optional') }})
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-content">
      <div class="h-full px-2 rounded bg-classen__secondary ">
        <input v-model="searchInput" type="text" :placeholder="getTranslation('search')"
               class="border-shadow rounded-20 search w-full ml-auto mr-auto mt-2 mb-2 pl-2">
        </input>

        <div class="text-left body flex flex-col">
          <div class="allSelections">
            <div class="overflow-y-auto row-span-4 allSelections text-base overscroll-contain">
              <div v-for="product in filteredProducts"
                   @click="selectedProduct = product; isOpen=false"
                   class="flex my-1 overscroll-contain selectionItem indent-text hover:bg-classen__secondary cursor-pointer">
                <p class="w-full text-center">{{ product.externalId }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import EventBus from "../../services/EventBus";
import Decors from "./Decors/Decors";
import Input from "../form/Input";
import getTranslation from "../../mixins/getTranslation";
import Button from "../Button";

export default {
  name: "ProductPicker",

  components: {Button, Input, Decors},

  props: {
    products: {required: false, type: Array},
  },

  created() {
    EventBus.listen('close-selection', this.closeSelection);
  },

  destroyed() {
    EventBus.destroy('close-selection', this.closeSelection);
  },

  mixins: [getTranslation],

  data() {
    return {
      isOpen: false,
      searchInput: '',
      createInput: '',
      added: false,
      hasError: true,
      selectedProduct: '',
    }
  },

  watch: {
    selectedProduct() {
      this.$emit('changedProduct', this.selectedProduct);
    }
  },

  computed: {
    filteredProducts() {
      if (this.products.length === 0) {
        return []
      }

      if (this.searchInput === '') {
        return this.products;
      }

      return this.products.filter((product) => {
        let externalId = product.externalId.toString();
        return externalId.includes(this.searchInput.toString());
      })
    },
  },

  methods: {
    lostFocus() {
      this.isOpen = false;
    },

    closeSelection() {
      this.isOpen = false
    },

    openSelection() {
      EventBus.fire('close-menus');
      EventBus.fire('close-selection');
      EventBus.fire('close-nav');
      this.isOpen = true;
    },
  },

  directives: {
    ClickOutside
  }

}
</script>

<style scoped>
.title-text {
  height: 50px;
  line-height: 50px;
  border-radius: 25px;
}

.title {
  height: 42px;
  border-radius: 25px 25px 0 0;
}

.displayed > .title {
  border: 1px solid #EAEBEC;
  border-bottom: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  width: 100%;
  height: fit-content;
  z-index: 1;
  border-radius: 0 0 20px 0;
  border: 1px solid #EAEBEC;
  border-top: none;
}

.displayed .dropdown-content {
  display: block;
}

.search {
  height: 35px;
}

.body {
  grid-template-rows: 120px 190px;
}

.selectionItem::first-letter {
  text-transform: capitalize;
}

.selectionItem {
  min-height: 20px;
}

.allSelections {
  height: 190px
}

.rounded {
  border-radius: 0 0 20px 0;
}
</style>
